<div id="ArmaShapeContainer-{{prefixId}}" class="div-canvas-input" [ngStyle]="mainDivCss">
    <canvas #armaShapeCanvas style="height: inherit"></canvas>
    <!-- Dessin des cotes ici (input) -->
    <input *ngFor="let custInput of mArrayInput; let i = index" 
        class="input-measure-after-canvas"
        [ngStyle]="generateCSSInputMeasure(custInput, i)"
        [(ngModel)]="mArrayCote[custInput.Id]"
        id="measure-{{prefixId}}-{{custInput.Id}}"
        [hidden]="!custInput.visible"
        autocomplete="off"
        [disabled]="mDisabledInput || isInputMeasureLocked()"
        [readonly]="!custInput.writable"
        (focus)="onInputFocus($event)">
</div>